import { render } from "./Steps2.vue?vue&type=template&id=a54e8676"
import script from "./Steps2.vue?vue&type=script&lang=js"
export * from "./Steps2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__